<template>
  <base-view title="Acompanhar integração - Marketplaces" class="mb-5 mr-4">
    <b-row class="mb-5">
      <b-col cols="12" class="mb-3">
        <div class="mb-2">
          Selecione o marketplace que deseja acompanhar a integração dos
          produtos:
        </div>
      </b-col>
      <b-col cols="12" class="d-flex align-items-center" v-if="loading">
        <b-spinner small class="mr-2" /> Carregando marketplaces
      </b-col>
      <b-col cols="12" class="d-flex align-items-center">
        <marketplace-select-card
          v-for="marketplace in marketplaces"
          :key="marketplace.id"
          :marketplace="marketplace"
          :selectedMarketplace="selectedMarketplace"
          @select="handleECommerceSelection(marketplace)"
          class="mr-4"
        />
      </b-col>
    </b-row>

    <b-row
      align-content="center"
      align-v="center"
      v-if="selectedMarketplace.id"
    >
      <b-col v-if="Object.keys(selectedMarketplace).length">
        <component
          :is="marketplaceListScreen"
          :marketplace="selectedMarketplace"
          :loading="loading"
        />
      </b-col>
    </b-row>
  </base-view>
</template>

<script>
import { mapState } from 'vuex';
import shopkeeperAppApi from '@/api/shopkeeperAppApi';
import makeToast from '@/mixins/makeToast';
import UserTypes from '@/enums/UserTypes';
import EnabledIntegrationStatus from 'Enums/Integration/EnabledIntegrationStatus';

import MarketplaceSelectCard from './_components/MarketplaceSelectCard.vue';
import MarketplaceMapFolder from './_components/map-folder';

export default {
  name: 'ListIntegrations',
  mixins: [makeToast],
  data() {
    return {
      EnabledIntegrationStatus,
      loading: false,
      selectedMarketplace: {},
      marketplaces: [],
    };
  },
  computed: {
    ...mapState(['dadosUsuario']),
    marketplaceListScreen() {
      if (!this.selectedMarketplace || !this.selectedMarketplace.type) return;

      const folder = MarketplaceMapFolder[this.selectedMarketplace.type];

      return () =>
        import(`./_components/${folder}/ListProductIntegrations.vue`);
    },
  },
  mounted() {
    this.getEcommerces();
  },
  methods: {
    async getEcommerces() {
      this.loading = true;

      const { data } = await shopkeeperAppApi.get(
        `/integration/marketplace/${this.userTypeId()}/integrations`
      );

      this.loading = false;

      this.marketplaces = data.data || [];
    },
    userTypeId() {
      return this.$route.meta.userType == UserTypes.BALCONISTA
        ? this.dadosUsuario.construp_user_id
        : this.dadosUsuario.id;
    },
    handleECommerceSelection(marketplace) {
      if (!marketplace.enabledIntegration) return;

      if (
        marketplace.enabledIntegration.status !==
        EnabledIntegrationStatus.ACTIVE
      )
        return;

      if (this.selectedMarketplace.id === marketplace.id) {
        this.selectedMarketplace = {};
        return;
      }

      this.selectedMarketplace = marketplace;
    },
  },
  components: {
    MarketplaceSelectCard,
  },
};
</script>

<style></style>
